enum DAO_EXPERIENCE_PARAMS {
    USER_PROPOSALS_PARAM = 'proposalsByUserAmount',
    USER_VOTES_PARAM = 'votesByUserAmount',
    USER_ORGANIZATION_PARAM = 'name',
}

export { DAO_EXPERIENCE_PARAMS };
